<template>
	<div class="order" :class="$store.state.auth.role" 
		v-if="['admin', 'manager', 'supervisor'].includes($store.state.auth.role)"
	>
		<div class="vx-row">
			<div class="vx-col w-full">
				<vx-card class="align-center">
					<div class="vx-row order__head">

						<div class="d-flex align-center flex-wrap vx-col order__head-col">

							<div class="vx-row order__head-col_inner">
								<div class="order__head-order vx-col">
									<b>{{ $t("order") }} №</b><span class="status">{{ model.id }}</span>
								</div>

							</div>
						</div>

					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-row">

			<div v-html="fullData.infoOrder" class="vx-col lg:w-1/2 w-full mt-8">

			</div>

			<div class="vx-col lg:w-1/2 w-full mt-8">
				<div v-html="fullData.toClientOrder" class="w-full">

				</div>
				<div v-html="fullData.toAuthorOrder" class="w-full">

				</div>
			</div>

		</div>
	</div>
</template>

<script>
import datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "Ai",
	mixins: [databaseManager, notifier],
	data() {
		return {
			model: { },
			fullData: {},
		};
	},
	components: {
		datepicker,
		vSelect,
	},
	watch: {

	},
	computed:{

	},
	methods: {
		sleep(milliseconds) {
			const date = Date.now();
			let currentDate = null;
			do {
				currentDate = Date.now();
			} while (currentDate - date < milliseconds);
		},
		async loadFullOrder() {
			let rez = await this.dbFullDataOrderAi(this.model.id);
			this.fullData = rez[0];
			console.log(this.fullData);
			console.log(rez);
		},
		async viewOrder() {
			const id = this.$route.params.id;
			return await this.dbViewOrder(id);
		},
	},
	async created() {
		const role = this.$store.state.auth.role;
		if(role === 'author') return;

		this.fullData.infoOrder = this.$t('firstLoadOrderInAi');

		this.model = await this.viewOrder();

		await this.loadFullOrder();
	},
};
</script>

<style lang="scss">
	@import "./src/assets/scss/vuexy/functions";
	@import "./src/assets/scss/vuexy/variables";

	.cursorPoint {
		cursor: pointer;
	}

	.align-center {
		align-items: center;
	}

	.vx-card__body {
		padding: 1rem 1.5rem !important;
	}

	.status {
		font-size: rem(14px);
		background-color: $primary;
		color: white;
		padding: 5px 10px;
		border-radius: 10px;
		flex-shrink: 0;

		&-ok {
			background-color: $success;
		}

		&-warn {
			background-color: $warning;
		}

		&-dang {
			background-color: $danger;
		}
	}
	
	.order {
		&__controls {
			.order__control {
				.vs-button {
					width: 100%;
					padding: 8px 15px !important
				}
			}

			@media screen and (max-width: 576px) {
				flex-direction: column;
				max-width: 470px;
				flex-wrap: nowrap;
			}
		}

		&__head {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			margin-top: -8px;
			margin-bottom: -8px;

			@media (max-width: 768px) {
				margin-top: -4px;
				margin-bottom: -4px;

				&-col {
					margin-top: 0px;
					margin-bottom: 4px;
				}
			}

			b {
				margin-right: 10px;
			}

			&-status,
			&-order {
				align-items: center;
				display: flex;
			}

			&-info {
				display: flex;
				align-items: center;
			}

			&-col {
				margin-top: 8px;
				margin-bottom: 8px;
			}
		}
	}

</style>
